import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetStudyDiagnostics } from 'icons/widgets';
import { getDataLoadRequests } from 'utils';

import { ISectionsVisibility } from '../../../api/types';
import PdfCommonDataEntityContainer from '../../../containers/pdfStudent/dataEntityContainers/common';
import { IRootState } from '../../../reducers';
import DiagnocticDoughnutStats from '../DiagnocticDoughnutStats/self';
import IndependentDiagnosticComponent from './IndependentDiagnostics';
import PersonalDiagnosticsComponent from './PersonalDiagnostics';

import './index.scss';

interface IPdfDiagnosticsProps {
  displaySettings: ISectionsVisibility | undefined;
}

const PdfDiagnostics = ({ displaySettings }: IPdfDiagnosticsProps) => {
  const independentDiagnostics = useAppSelector((state: IRootState) => state.independentDiagnostics.content);
  const selfDiagnostics = useAppSelector((state: IRootState) => state.studentDiagnosis?.content);
  const personalDiagnostics = useAppSelector((state: IRootState) => state.personalDiagnostics.content);

  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().pdfDiagnostics });

  return (
    <PdfCommonDataEntityContainer title="Диагностики" Icon={IconWidgetStudyDiagnostics}>
      {displaySettings?.independentDiagnostic && independentDiagnostics.length !== 0 && (
        <div className="pdf-diagnostic-block">
          <h5 className="pdf-diagnostic-block__title">Независимые диагностики</h5>
          <IndependentDiagnosticComponent independentDiagnostics={independentDiagnostics} />
        </div>
      )}
      {displaySettings?.personalDiagnostic && (
        <div className="pdf-diagnostic-block">
          <h5 className="pdf-diagnostic-block__title">Индивидуальные диагностики</h5>
          <PersonalDiagnosticsComponent personalDiagnostics={personalDiagnostics} />
        </div>
      )}
      {displaySettings?.selfDiagnostic && selfDiagnostics && (
        <div className="pdf-diagnostic-block pdf-keep">
          <h5 className="pdf-diagnostic-block__title">Пройденные диагностики за все время</h5>

          <DiagnocticDoughnutStats studentDiagnosis={selfDiagnostics} bestSubject={selfDiagnostics.bestResult} />
        </div>
      )}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfDiagnostics;
